import api from './api';
import API_ROUTES from './apiRoutes';

const gameService = {
  // Create a new game
  createGame: async (gameData) => {
    const response = await api.post(API_ROUTES.SUPER_ADMIN.CREATE_GAME, gameData);
    return response.data;
  },

  // Get all games with pagination
  getGames: async (params = {}) => {
    const { page = 1, limit = 10 } = params;
    const response = await api.get(API_ROUTES.SUPER_ADMIN.GET_GAMES, {
      params: { page, limit }
    });
    return response.data;
  },

  // Get game by ID
  getGameById: async (id) => {
    const response = await api.get(API_ROUTES.SUPER_ADMIN.GET_GAME_BY_ID(id));
    return response.data;
  },

  // Update game status
  updateGameStatus: async (id, status) => {
    const response = await api.patch(API_ROUTES.SUPER_ADMIN.UPDATE_GAME_STATUS(id), {
      status
    });
    return response.data;
  },

  // Delete game
  deleteGame: async (id) => {
    const response = await api.delete(API_ROUTES.SUPER_ADMIN.DELETE_GAME(id));
    return response.data;
  },
};

export default gameService;
